<!-- sso-login.component.html -->
<main class="sso-login">
    <div class="login-container">
        <!-- Logo/Brand Section -->
        <div class="brand-section">
            <div class="logo-wrapper">
                <svg class="logo-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
                    <path d="M2 17L12 22L22 17" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
                    <path d="M2 12L12 17L22 12" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
                </svg>
                <span class="brand-name">YourApp</span>
            </div>
        </div>

        <!-- Main Content -->
        <div class="login-content">
            <!-- Loading State -->
            <div *ngIf="!errorMessage" class="loading-state">
                <div class="spinner-wrapper">
                    <div class="spinner"></div>
                </div>
                <h2 class="loading-title">Signing You In</h2>
                <p class="loading-description">Please wait while we securely authenticate your credentials...</p>
                
                <!-- Decorative Progress Dots -->
                <div class="progress-dots">
                    <span class="dot active"></span>
                    <span class="dot"></span>
                    <span class="dot"></span>
                </div>
            </div>

            <!-- Error State -->
            <div *ngIf="errorMessage" class="error-state">
                <div class="error-icon-wrapper">
                    <svg class="error-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
                        <path d="M12 8V12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                        <path d="M12 16H12.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                </div>
                <h2 class="error-title">Authentication Failed</h2>
                <p class="error-message">{{ errorMessage }}</p>
                <button class="retry-button" (click)="retryLogin()">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M21 2V8H15"/>
                        <path d="M3 12C3 7.02944 7.02944 3 12 3C15.9135 3 19.265 5.71776 20.5589 9.29289"/>
                        <path d="M21 12C21 16.9706 16.9706 21 12 21C8.08654 21 4.73505 18.2822 3.44112 14.7071"/>
                        <path d="M3 16V22H9"/>
                    </svg>
                    Try Again
                </button>
                <a class="help-link" href="/support">Need help? Contact Support</a>
            </div>
        </div>

        <!-- Footer -->
        <div class="login-footer">
            <p class="footer-text">Secure SSO Authentication • v2.0</p>
        </div>
    </div>
</main>